module.exports = __webpack_public_path__ + "static/media/usb.7a1f2fe0.png";